// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__CTtof","namePhoneContainer":"style_namePhoneContainer__A3r1S"};